module.exports = __webpack_public_path__ + "static/media/checked.d556d7b2.png";